/*  iceberg-ui  */
import { IconWithVariant } from '@auviknetworks/iceberg-ui';

/*  Shared  */
import { FontSizes } from 'application/Shared/Constants';

/*  React  */
import React from 'react';

export const Windows = ({
    size = FontSizes[1],
    style,
    variant = 'primary'
}) => (
    <IconWithVariant
        data-testid="windowsIcon"
        variant={variant}
        src="Windows"
        size={size}
        wrapperProps={{ ...style }}
    />
);
